import $ from "jquery";
export default class TextareaCounter {
    static mount($nodes, counterSelector) {
        let instances = [];
        $nodes.each(function () {
            instances.push(new TextareaCounter($(this), counterSelector));
        });
        return instances;
    }
    constructor($targetNode, counterSelector) {
        this.$targetNode = $targetNode;
        this.$textAreas = $("textarea", this.$targetNode);
        this.$textAreaCounterValue = $(counterSelector, this.$targetNode);
        this.$textAreas.on('input', () => { this.update(); });
        this.update();
    }
    update() {
        let newCount = 0;
        this.$textAreas.each(function () {
            var _a;
            let val = String((_a = $(this).val()) !== null && _a !== void 0 ? _a : '');
            newCount += val.length;
        });
        this.count = newCount;
        let numberString = new Intl.NumberFormat("de-DE").format(this.count);
        this.$textAreaCounterValue.html(numberString);
    }
    setInvalid(invalid) {
        if (invalid) {
            this.$textAreaCounterValue.addClass('is-invalid');
        }
        else {
            this.$textAreaCounterValue.removeClass('is-invalid');
        }
    }
}
